export { default } from "./Icon.js";
export { default as iconClasses } from "./iconClasses.js";
export * from "./iconClasses.js";